import { useMemo } from 'react';
import { useAuth } from 'contexts/AuthContext';

export function useAccountingView() {
  const { user } = useAuth();

  return useMemo(() => {
    const mode = user?.accountingViewMode || user?.accounting_view_mode || 'internal';
    const canToggle = Boolean(user?.isDirector || user?.isAdmin);
    return {
      accountingViewMode: mode,
      isTaxView: mode === 'tax',
      isInternalView: mode !== 'tax',
      canToggleAccountingView: canToggle,
    };
  }, [user]);
}
